// extracted by mini-css-extract-plugin
export default {"table":"EFehA","headCell":"lBVTH","row":"vPYFG","rowCell":"G_AXL"};